import React, { Component } from 'react'
import { withPrefix } from 'gatsby'

import abcLeft from '../images/abc-left.svg'
import abcRight from '../images/abc-right.svg'

export default class LogoHeader extends Component {
  constructor(props) {
    super(props)
    this.logoRef = React.createRef()
    this.state = {
      background: 'pink',
      yPosition: 0,
    }
  }
  // componentDidMount() {
  //   window.addEventListener('scroll', this.handleScroll, { passive: true })
  // }
  // componentWillMount() {
  //   window.removeEventListener('scroll', this.handleScroll)
  // }
  // handleScroll = e => {
  //   const logoRef = this.logoRef.current
  //   const { y } = logoRef.getBoundingClientRect()
  //   this.setState({ yPosition: y })
  //   // console.log(y)
  //   // const logoRef = this.logoRef.current
  //   // const { y } = logoRef.getBoundingClientRect()
  //   // if (y <= 0) this.setState({ background: 'yellow' })
  // }
  render() {
    return (
      <div className="abc-logo-container" ref={this.logoRef}>
        <img
          src={abcLeft}
          className="abc-left"
          alt="ABC logo broken in half. The left side."
          style={{ transform: `translateX:${this.state.yPosition}px` }}
        />
        <img src={abcRight} alt="ABC logo broken in half. The right side." className="abc-right" />
      </div>
    )
  }
}
